import { ConfigType } from "./types";

export const BOS_SETTINGS_ROUTE = "/bos-settings";

// The legacy AngularJS console path for this page (behind the hash router).
export const LEGACY_CONSOLE_PATH = "/#!/bosSettings";

// $scope.configTypetoPrettyName in hostnameConfigController.js.
export const CONFIG_TYPE_PRETTY_NAME: Record<ConfigType, string> = {
  hostedByBbot: "Menu-only, hosted by Bbot",
  basicDeliveryTheme: "Menu-only BOS",
  preBuilt: "Pre-built BOS",
  bosBuilder: "Customizable BOS",
  redirectToHostname: "Redirects to another domain",
  notConfigured: "Not yet configured",
};

export const HOSTNAME_CONFIG_PAGE_SIZE_OPTIONS = [10, 20, 50];
